import { Component } from '@angular/core';
import { ACDATAConnectorPanel } from '../a.cdata.connector.panel';
import { CDATAConnectorInfo } from '../../../../../../../models/datamodel/adbinfo.model';

@Component({
    selector: 'office365-connector-panel',
    templateUrl: './office365.connector.panel.html'
})
export class Office365ConnectorPanel extends ACDATAConnectorPanel {
    static GetInfo(): CDATAConnectorInfo {
        return {
            Caption: '@@Office 365',
            Type: 'evidanza.Database.CData.CDataConnector.ConnectorsInfo.Office365Info',
            ControlType: Office365ConnectorPanel,
            Default: null
        };
    }
}
